var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42859 20.3408C1.42859 19.5518 2.06818 18.9122 2.85716 18.9122H8.9126C9.70157 18.9122 10.3412 18.2726 10.3412 17.4837V11.3957C10.3412 10.6068 10.9808 9.96717 11.7697 9.96717H17.8252C18.6142 9.96717 19.2537 9.32758 19.2537 8.5386V2.85728C19.2537 2.0683 19.8933 1.42871 20.6823 1.42871H27.1429C27.9319 1.42871 28.5714 2.0683 28.5714 2.85728V26.4287C28.5714 27.2177 27.9319 27.8573 27.1429 27.8573H2.85716C2.06818 27.8573 1.42859 27.2177 1.42859 26.4287V20.3408Z",
    fill: "#FFCA23"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/select-icon.77f27f5b2df85976e0e7d12528d4d8bd.svg";
export { ForwardRef as ReactComponent };